import {FilterParams} from '../../../networking/repos/SubjectAreaRepository';

export const SubjectAreaQueryKey = {
    base: ['subject-areas'],
    filterOptions: ['subject-areas', 'filters'],
    filtered: (params: FilterParams) => ['subject-areas', params]
};
